module.exports = __webpack_public_path__ + "static/xmasbowhamper-6f3d9bf95c84d022e60789fc6d2c83fc.jpeg";